import { AxiosResponse } from 'axios';
import baseAPI from '@/api';
import { LuckySpin } from '@/models/userReward/lucky-spin/lucky-spin';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';

export async function getLuckySpins() {
  const response: AxiosResponse<PaginatedResponse<LuckySpin>> =
    await baseAPI.get<PaginatedResponse<LuckySpin>>('/lucky-spins');

  return response.data;
}
